export default "__VITE_ASSET__CLikg6RX__"